// extracted by mini-css-extract-plugin
module.exports = {"root":"bufKj__root","sectionWrapper":"_1OtfR__sectionWrapper","supplementalContentItem":"_1-sry__supplementalContentItem","fileIcon":"_1-7N0__fileIcon"};